import script from "./patchAppDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./patchAppDetail.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__